import { FullPageError } from "@/components/ui/system-state";

export default function RouteNotFoundPage() {
  return (
    <main className="flex min-h-screen w-full items-center justify-center p-6">
      <div className="w-full max-w-[640px]">
        <FullPageError
          code="404"
          codeTone="primary"
          title="Page not found"
          description="The page you requested does not exist or may have been moved. Check the address or return to a known location."
          homeHref="/home"
          homeLabel="Back to home"
        />
      </div>
    </main>
  );
}
